/**
 * Detects and sets the user's language preference based on stored value or geolocation
 * @param {Object} config - Application configuration containing API base URL
 * @param {Object} store - Vuex store for state management
 * @returns {Promise<void>}
 */
export async function detectAndSetUserLanguage(config, store) {

  const USER_LANG_KEY = 'selectedLocale';
  const USER_COUNTRY_KEY = 'country';
  const USER_CITY_KEY = 'city';
  const storedLanguage = localStorage.getItem(USER_LANG_KEY);
  const storedCountry = localStorage.getItem(USER_COUNTRY_KEY);

  // If we already have a stored language preference, use it
  if (storedLanguage && storedCountry) {
    return;
  }
  
  try {
    // If no stored preference, call the backend to detect language based on IP
    const response = await fetch(`${config.apiBaseUrl}/users/location`);
    
    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.data && data.data.language) {
      
      const { data: { language, country = '', city = '' } } = data;
      
      if (!language) {
        // If no language was detected, fall back to default
        throw new Error('No language information received');
      }

      // Save the detected info for future use
      if (!storedLanguage) {
        localStorage.setItem(USER_LANG_KEY, language);
        store.commit('SET_STATE_PROPERTY', { property: 'locale', value: language });
      }

      localStorage.setItem(USER_COUNTRY_KEY, country);
      localStorage.setItem(USER_CITY_KEY, city);
      
      return;
    }
    
    // If no language was detected, fall back to default
    throw new Error('No language information received');
    
  } catch (error) {
    console.error('Error detecting user language:', error.message);
    store.commit('SET_STATE_PROPERTY', { property: 'locale', value: 'en' });
  }
}

// Default export for convenience
export default detectAndSetUserLanguage;
